import { SectionHeader } from '@/components/marketing/section-header'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export function FeatureShowcase({
  kicker,
  title,
  lead,
  imageSrc,
  imageAlt,
  ctaLabel,
  ctaHref,
  className,
  children,
}: {
  kicker?: string
  title: string
  lead?: string
  imageSrc?: string
  imageAlt?: string
  ctaLabel?: string
  ctaHref?: string
  className?: string
  children?: React.ReactNode
}) {
  const showCta = Boolean(ctaLabel && ctaHref)

  return (
    <section className={cn('marketing-section', className)}>
      <div className="marketing-container">
        <div className={cn('feature-showcase__header', showCta && 'feature-showcase__header--with-cta')}>
          <SectionHeader
            eyebrow={kicker}
            title={title}
            lead={lead}
            className="feature-showcase__copy"
          />
          {showCta ? (
            <Button asChild variant="cta" size="cta">
              <a href={ctaHref} className="feature-spotlight__cta feature-showcase__cta">
                {ctaLabel}
              </a>
            </Button>
          ) : null}
        </div>
        {imageSrc || children ? (
          <div className="feature-showcase__body">
            {imageSrc ? (
              <div className="feature-showcase__diagram">
                <img
                  src={imageSrc}
                  alt={imageAlt ?? title}
                  width={1024}
                  height={436}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ) : null}
            {children}
          </div>
        ) : null}
      </div>
    </section>
  )
}
